import { render, staticRenderFns } from "./KeyboardCleanPage.vue?vue&type=template&id=e0d4aa44&scoped=true"
import script from "./KeyboardCleanPage.vue?vue&type=script&lang=js"
export * from "./KeyboardCleanPage.vue?vue&type=script&lang=js"
import style0 from "./KeyboardCleanPage.vue?vue&type=style&index=0&id=e0d4aa44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d4aa44",
  null
  
)

export default component.exports